import React, { useState } from "react";
import { PLAN_PERIODS, formatRand, usePlans } from "./utils/marksurePlans";

const API_BASE = "https://marksure.tech/api";

const RenewButton = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("teacher_term");
  // Prices come from the app's own API (local while developing); checkout stays on API_BASE.
  const { plans, error } = usePlans(String(process.env.REACT_APP_API_URL || API_BASE).replace(/\/$/, ""));
  const chosen = plans.find((plan) => plan.id === selectedPlan) || plans[0];

  const handleRenewal = async () => {
    if (!chosen) return;
    setLoading(true);
    try {
      // 1. Talk to your API
      const response = await fetch(`${API_BASE}/create_public_subscription.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          plan: chosen.id, // Send the chosen plan
          user_id: user.id, // Send the user ID (Critical for unlocking)
        }),
      });

      const result = await response.json();

      if (result.redirectUrl) {
        // 2. Go to Yoco
        window.location.href = result.redirectUrl;
      } else {
        alert("Connection error: " + (result.error || "Unknown error"));
      }
    } catch (error) {
      console.error(error);
      alert("Error initiating payment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        width: "100%",
        maxWidth: "300px",
      }}
    >
      {error && <span style={{ color: "#a03a2a", fontSize: "14px" }}>{error}</span>}
      {/* Plan Selector */}
      <select
        value={chosen?.id || ""}
        onChange={(e) => setSelectedPlan(e.target.value)}
        disabled={plans.length === 0}
        style={{
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          fontSize: "16px",
          width: "100%",
        }}
      >
        {plans.length === 0 && <option value="">Loading plans…</option>}
        {PLAN_PERIODS.map((period) => (
          <optgroup key={period.id} label={period.label}>
            {plans.filter((plan) => plan.period === period.id).map((plan) => (
              <option key={plan.id} value={plan.id}>
                {plan.label} - {formatRand(plan.price_cents)} / {period.suffix} ({plan.scripts} scripts)
              </option>
            ))}
          </optgroup>
        ))}
      </select>

      {/* Pay Button */}
      <button
        onClick={handleRenewal}
        disabled={loading || !chosen}
        style={{
          backgroundColor: "#FF9800",
          color: "white",
          padding: "12px 24px",
          border: "none",
          borderRadius: "8px",
          fontSize: "16px",
          fontWeight: "bold",
          cursor: loading ? "wait" : "pointer",
        }}
      >
        {loading
          ? "Loading Payment..."
          : chosen ? `Renew for ${formatRand(chosen.price_cents)}` : "Renew"}
      </button>
    </div>
  );
};

export default RenewButton;
